module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLogined && !_vm.isError) ? _c('div', {
    staticClass: "wechatPayContent"
  }, [_c('div', {
    staticClass: "wechatPayHead"
  }, [_c('div', {
    staticClass: "payHead1"
  }, [_vm._v("请及时付款，以便订单尽快处理！")]), _vm._v(" "), _c('div', {
    staticClass: "payHead2"
  }, [_c('div', {
    staticClass: "countdown"
  }, [_vm._v("请在"), _c('span', [_vm._v(_vm._s(_vm.timecount))]), _vm._v("内付款，否则交易会被取消")]), _vm._v(" "), _c('div', {
    staticClass: "orderAmount"
  }, [_vm._v("￥" + _vm._s(Number(_vm.orderTotal).toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "payLabel"
  }, [_vm._v("实付：")])])]), _vm._v(" "), _c('div', {
    staticClass: "wechatPayContent"
  }, [_c('div', {
    staticClass: "payContentLeft"
  }, [_c('div', {
    staticClass: "pic"
  }, [_c('div', {
    ref: "qrcodeContainer"
  })]), _vm._v(" "), (_vm.timeout) ? _c('div', {
    staticClass: "timeout"
  }, [_c('div', [_vm._v("二维码已过期")])]) : _c('div', {
    staticClass: "prompt"
  }, [_c('div', [_vm._v("微信扫码支付")])]), _vm._v(" "), (_vm.timeout) ? _c('div', {
    staticClass: "refresh",
    on: {
      "click": _vm.refresh
    }
  }, [_c('div', [_vm._v("刷新")])]) : _vm._e()]), _vm._v(" "), _vm._m(0)])]) : _c('div', {
    staticClass: "wechatPayContent1"
  }, [(!_vm.isLogined) ? _c('div', {
    on: {
      "click": function($event) {
        return _vm.toLogin()
      }
    }
  }, [_vm._v("亲,请先登陆")]) : _c('div', {
    staticClass: "errorMsg"
  }, [_vm._v(_vm._s(_vm.errorMsg))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payContentRight"
  }, [_c('img', {
    attrs: {
      "src": "http://img.static.knnnj.com/Default/a83350bf-bffe-478a-931d-ee5ec03b633f.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f621f91e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/wechat.vue
// module id = 792
// module chunks = 2